import styled from "@emotion/styled";
import { OutlinedTextFieldProps, TextField } from "@mui/material";

interface StyledInputProps extends Partial<OutlinedTextFieldProps> {
  colored?: boolean;
  enlarge?: boolean;
  label?: string;
  fixedPart?: string;
  maxLength?: number;
}

const CustomInput = styled(TextField)<StyledInputProps>(
  ({ size, colored, enlarge }) => ({
    ...(colored && {
      ".Mui-focused": {
        color: "var(--primary-color)",
      },
    }),
    ...(size === "small" && {
      ".MuiOutlinedInput-root": {
        height: "50px",
      },
      ".MuiInputLabel-root": {
        top: "3px",
      },
      ".MuiInputLabel-shrink": {
        top: "-1px",
      },
    }),
    ...(enlarge && {
      ".MuiOutlinedInput-root": {
        height: "70px",
        fontSize: "22px",
      },
      ".MuiInputLabel-root": {
        fontSize: "22px",
        top: "3px",
      },
      ".MuiInputLabel-shrink": {
        top: "-3px",
      },
    }),
  })
);

const StyledInput = ({ ...props }: StyledInputProps) => {
  const { fixedPart, onChange, onBlur, type } = props;

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (type === "file") {
      onBlur?.(e);
      return;
    }

    onBlur?.(e);
    if (fixedPart && !e.target.value.startsWith(fixedPart)) {
      e.preventDefault();
      e.target.value = fixedPart + e.target.value;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === "file") {
      onChange?.(e);
      return;
    }

    onChange?.(e);
    if (fixedPart && !e.target.value.startsWith(fixedPart)) {
      e.preventDefault();
      e.target.value = fixedPart + e.target.value;
    }
  };

  return (
    <CustomInput
      onBlur={handleBlur}
      onChange={handleChange}
      fullWidth
      InputLabelProps={{ shrink: type === "file" ? true : undefined }}
      {...props}
    />
  );
};

export default StyledInput;
